export default {
  path: '/2019Zxqyxcy',
  name: '2019Zxqyxcy',
  component: () => import('./Home.vue'),
  redirect: '/2019Zxqyxcy/SelectRules',
  meta: {
    title: '中小企业政策宣传月',
  },
  children: [
    {
      path: 'SelectRules',
      component: () => import('./SelectRules.vue'),
      name: '2019Zxqyxcy/SelectRules',
      meta: {
        title: '中小企业政策宣传月',
      },
    },
    {
      path: 'Interpretation',
      component: () => import('./Interpretation.vue'),
      name: '2019Zxqyxcy/DetailPage',
      meta: {
        title: '中小企业政策宣传月',
      },
      children: [
        {
          path: 'policyDetail',
          component: () => import('./PolicyDetail.vue'),
          name: '2019Zxqyxcy/policyDetail',
          meta: {
            title: '中小企业政策宣传月',
          },
        },
      ],
    },
    {
      path: 'RelativeNews',
      component: () => import('./RelativeNews.vue'),
      name: '2019Zxqyxcy/RelativeNews',
      meta: {
        title: '中小企业政策宣传月',
      },
    },
  ],
};
